import React from "react";
import { Button, ButtonProps } from "@mui/material";

interface ByzMuiLayoutButtonProps extends Omit<ButtonProps, 'variant'> {
  width?: string;
  height?: string;
  text: string;
}

const ByzMuiLayoutButton: React.FC<ByzMuiLayoutButtonProps> = ({
  width = "auto",
  height = "auto",
  text,
  onClick,
  sx,
  ...rest
}) => {
  return (
    <Button
      variant="outlined"
      onClick={onClick}
      sx={{
        width: width,
        height: height,
        border: "1px solid #2F80ED",
        borderRadius: "4px",
        fontFamily: "Inter",
        fontWeight: 400,
        fontSize: "14px",
        lineHeight: "100%",
        letterSpacing: "0%",
        textTransform: "none",
        color: "#2F80ED",
        "&:hover": {
          border: "1px solid #2F80ED",
          backgroundColor: "rgba(47, 128, 237, 0.04)",
        },
        ...sx,
      }}
      {...rest}
    >
      {text}
    </Button>
  );
};

export default ByzMuiLayoutButton;

